import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable, of } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';

import { PhoneNumbers } from 'src/app/shared/models/phoneNumbers.model';

import { environment } from 'src/environments/environment';

export enum FormatType {
  E164 = 'E164',
  INTERNATIONAL = 'INTERNATIONAL',
  NATIONAL = 'NATIONAL',
  RFC3966 = 'RFC3966'
}

export interface FormatValidationMessage {
  countryISOCode2: string;
  formattedPhoneNumbers: string[];
  phoneNumbers: string[];
  phoneNumberFormat: FormatType;
  invalidPhoneNumbers: string[];
}

@Injectable({
  providedIn: 'root'
})
export class PhoneService {
  public countryCode = 'GB';
  public phoneCode = '+44';
  public formatType = FormatType.INTERNATIONAL;
  public phone: string;
  public phoneHref: string;

  constructor(
    private http: HttpClient,
  ) {}

  validatePhoneNumber(phoneNumber: string): Observable<any> {
    return this.http.post(`${environment.apiUrl}phones/validate/phone`, {
      countryISOCode2: this.countryCode,
      formattedPhoneNumbers: [],
      phoneNumbers: [`${this.phoneCode}${phoneNumber}`],
      phoneNumberFormat: this.formatType,
      invalidPhoneNumbers: []
    });
  }

  updatePhoneNumbers(): Observable<any> {
    return this.http.get(`${environment.apiUrl}phones/phone-numbers?timestamp=${Date.now()}`)
      .pipe(
        tap((phones: PhoneNumbers) => {
          this.phone = phones.localNumberFormatted;
          this.phoneHref = phones.localNumberUnformatted;
        }),
        catchError(() => of(null))
      );
  }
}
